export default __webpack_public_path__ + "static/media/Instagram_logo_2016.91084741.svg";